import React from 'react';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router';

import Button from 'components/Button';
import SearchFilter from 'components/Filters/SearchFilter';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import {openModal, MODALS as BASE_MODALS} from 'ducks/modals';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<
  SubNavigationProps &
    RouteComponentProps<{locationRef: string}> &
    typeof mapDispatchToProps
> {
  openBookingCreateModal = () =>
    this.props.requiresPermission(
      {
        locationRef: this.props.match.params.locationRef,
        permission: PERMISSIONS.CREATE_BOOKING
      },
      () => this.props.openModal(BASE_MODALS.CREATE_BOOKING)
    );

  render() {
    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered">
        <SearchFilter
          value={this.props.filters.search}
          onChange={(search: string) => this.props.setFilter('search', search)}
        />
        <Button white onClick={this.openBookingCreateModal}>
          Create Booking
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = {
  requiresPermission,
  openModal
};

export default withRouter(
  connect(null, mapDispatchToProps)(SubNavigation)
) as React.ComponentType<SubNavigationProps>;
